import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS
import Typography from '@material-ui/core/Typography'
import LeftNavigationDashboard from '../components/app-navigation/LeftNavigationDashboard'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import LogoData from '../components/app-logo/logo-data'
import CustomizeAll from '../components/сustomize-all/'
import Wrapper from '../components/wrapper'
import { format } from 'date-fns'
import LicenseExpired from '../components/payment/LicenseExpired'
import { ActionsForUsing } from '../components/payment/LicenseExpired'
import { thousandSeparator } from '../utils/Utils'

// Import React Table
import ReactTable from 'react-table'
import 'react-table/react-table.css'

import { Important, Rub } from '../components/app-icon/Icons'

const styles = theme => ({
  pageTemplate: {
    maxWidth: 1072,
    margin: '0 auto',
  },
  wizardRow: {
    padding: '0 24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    marginBottom: 32,
  },
  wizardContent: {
    maxWidth: 980,
    width: '100%',
  },
  crmsList: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  header: {
    padding: '15px 40px 6px 22px',
  },
  content: {
    padding: '16px 40px 30px 22px',
  },
  viewList: {
    margin: 0,
    padding: 0,
  },

  list: {
    padding: 0,
    listStyleType: 'none',
  },
  item: {
    marginBottom: 12,
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(136, 102, 255)',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  icon: {
    width: 40,
    height: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 16px 32px 0 rgba(0, 0, 0, 0.12)',
    backgroundColor: 'rgb(255, 204, 0)',
    borderRadius: '100%',
    marginRight: 15,
  },
  chanelList: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
  },
  chanel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '13px 15px 13px 32px',
  },
  chanelInfo: {
    listStyleType: 'none',
    padding: 0,
    marginLeft: 8,
    marginRight: 65,
    flex: 1,
  },
  chanelTitle: {
    fontFamily: 'Roboto',
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.75)',
  },
  chanelStatus: {
    fontFamily: 'Roboto',
    fontSize: 10,
    lineHeight: 1.6,
    color: 'rgba(0, 0, 0, 0.5)',
  },
  chanelStatusIcon: {
    width: 16,
    height: 16,
    minWidth: '16px',
  },

  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: theme.spacing.unit * 3,
    paddingBottom: theme.spacing.unit * 3,
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2,
    [theme.breakpoints.up('md')]: {},
    '@media (min-width:960px)': {
      // eslint-disable-line no-useless-computed-key
      paddingLeft: theme.spacing.unit * 8,
      paddingRight: theme.spacing.unit * 8,
    },
  },
  link: {
    textDecoration: 'none',
  },
  toolbarInner: {
    padding: 0,
  },
  extendedIcon: {
    marginRight: 5,
  },
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: 32,
    background: '#fff',
    borderRadius: 32,
  },
  info: {
    margin: 0,
    padding: 0,
    flex: 1,
  },
  siteIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 24,
    height: 24,
    margin: '0 19px 0 23px',
    color: '#fff',
    fontSize: 16,
    fontWeight: 600,
    borderRadius: '100%',
    backgroundColor: 'rgb(44, 50, 157)',
  },
  list: {
    margin: '0 0 16px 0',
    padding: '7px 20px 10px 40px',
    listStyleType: 'none',
    borderRadius: 4,
  },
  user: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0)',
  },
  avatar: { width: 22, height: 22, marginRight: 10 },
  item: {
    position: 'relative',
    fontFamily: 'Roboto',
    fontSize: 12,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.33,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0, .75)',
    '&::before': {
      content: '"↳"',
      marginRight: 5,
    },
  },
  dataIcon: {
    width: 16,
    height: 16,
    fill: 'rgba(0, 0, 0, .5)',
  },
  gaSymbol: {
    width: 36,
    height: 36,
  },
  chanelError: {
    backgroundColor: 'rgba(255, 59, 48, 0.1)',
  },
  chanelStatus: {
    fontFamily: 'Roboto',
    fontSize: 10,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.2,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0, .5)',
  },
  chanelStatusError: {
    color: 'rgb(255, 59, 48)',
  },
  '@keyframes greyPulse': {
    '0%': {
      backgroundColor: 'grey',
    },
    '50%': {
      backgroundColor: '#BBB',
    },
    '100%': {
      backgroundColor: 'grey',
    },
  },
  '@keyframes trianglePulse': {
    '0%': {
      borderColor: 'grey transparent transparent transparent',
    },
    '50%': {
      borderColor: '#BBB transparent transparent transparent',
    },
    '100%': {
      borderColor: 'grey transparent transparent transparent',
    },
  },
  tooltip: {
    position: 'absolute',
    whiteSpace: 'pre-line',
    backgroundColor: '#000',
    color: '#fff',
    borderRadius: 4,
    fontSize: 14,
    padding: '5px 8px',
    top: -22,
    left: 24,
    zIndex: 10,
    animationName: 'greyPulse',
    animationIterationCount: 'infinite',
    animationDuration: '1.4s',
    '&::after': {
      content: '" "',
      position: 'absolute',
      bottom: 0,
      left: 31,
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '7px 5px 0 5px',
      borderColor: '#000000 transparent transparent transparent',
      transform: 'translateY(100%)',
      animationName: 'trianglePulse',
      animationIterationCount: 'infinite',
      animationDuration: '1.4s',
    },
  },

  crmList: {
    paddingTop: '20px',
  },
  crmWrapper: {
    paddingTop: '10px',
  },
  crmBlock: {
    marginTop: '16px',
    width: '350px',
    borderRadius: '16px',
    boxShadow: '0 8px 16px 0 rgba(0, 0, 0, 0.1)',
    backgroundColor: '#ffffff',
    padding: '16px 14px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '14px',
  },
  existedCrmBlock: {
    marginTop: '16px',
    width: '350px',
    borderRadius: '16px',
    boxShadow: '0 8px 16px 0 rgba(0, 0, 0, 0.1)',
    backgroundColor: '#ffffff',
    padding: '16px 14px',
  },
  crmButton: {
    width: '126px',
    height: '32px',
    lineHeight: '32px',
    fontSize: '12px',
    fontWeight: '500',
    textAlign: 'center',
    borderRadius: '4px',
    backgroundColor: '#ffcc00',
    outline: 'none',
    textDecoration: 'none',
    color: '#000',
  },
  crmButtonNew: {
    width: '126px',
    height: '32px',
    lineHeight: '32px',
    fontSize: '12px',
    fontWeight: '500',
    textAlign: 'center',
    borderRadius: '4px',
    border: 'solid 1px #8866ff',
    backgroundColor: '#fff',
    outline: 'none',
    textDecoration: 'none',
    color: '#000',
  },
  newCrm: {
    width: '188px',
  },
  crmStatisticBlock: {
    marginTop: '10px',
  },
  crmStatisticWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginTop: '10px',
  },
  crmDescription: {
    opacity: '0.75',
    fontSize: '12px',
  },
  crmsWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  statisticData: {
    opacity: '0.5',
    fontFamily: 'Roboto',
    fontSize: '10px',
    wordBreak: 'break-all',
  },
  statisticTitle: {
    opacity: '0.75',
    fontFamily: 'Roboto',
    fontSize: '14px',
  },
  errors: {
    color: '#ff3b30',
    fontFamily: 'Roboto',
    fontSize: '10px',
  },

  action: {
    fontSize: 14,
    fontWeight: 500,
    color: 'rgb(0, 0, 0)',
    whiteSpace: 'pre-line',
  },
  icon: {
    marginRight: 16,
  },
  description: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    padding: 16,
    cursor: 'pointer',
  },

  appBar: {
    position: 'relative',
  },
  paper: { backgroundColor: '#ffcc00' },
  modalTitle: {
    marginBottom: 24,
    textAlign: 'center',
  },
  modalIcon: {
    marginBottom: 16,
  },
  subTitle: {
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: 'rgb(0, 0, 0)',
    whiteSpace: 'pre-line',
  },
  tableWrapper: {
    width: '100%',
    marginTop: '30px',
    borderRadius: '8px',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.1)',
  },
  tableTd: {
    textAlign: 'center',
  },
  balance: {
    fontWeight: 'bold',
    marginBottom: 16,
  },
  referalValue: {
    marginRight: 5,
  },
})

class Referral extends Component {
  constructor(props) {
    super(props)
    this.state = {
      site: window.state.site,
      user: window.state.user,
      referral_link: window.state.referral_link,
      table_data: window.state.data.items,
      balance: window.state.data.balance,
    }
  }

  render() {
    const { classes } = this.props
    const { site, user } = this.state

    return (
      <Fragment>
        {user.wizard_finished_at && (
          <LicenseExpired>
            <ActionsForUsing />
          </LicenseExpired>
        )}
        <div className={classes.pageTemplate}>
          <AppBar
            position="static"
            color="inherit"
            elevation={0}
            style={{ padding: '24px' }}
          >
            <Toolbar className={classes.toolbarInner}>
              <LogoData />
              <a className={classes.container} href={`http://${site.url ? site.url.replace(/(http|https):\/\//is, '') : ''}`} target="_blank">
                <div className={classes.siteIcon}>S</div>
                <ul className={classes.info}>
                  <Typography component="li" variant="body1">
                    {site.url}
                  </Typography>
                  <Typography component="li" variant="overline">
                    {site.name}
                  </Typography>
                </ul>
              </a>
            </Toolbar>
          </AppBar>

          <CustomizeAll />

          <div className={classes.wizardRow}>
            <LeftNavigationDashboard />

            <div className={classes.wizardContent}>
              <Wrapper shadow={4}>
                <section style={{ padding: '24px 48px', position: 'relative' }}>
                  <Typography variant="h3" style={{ marginBottom: 20 }}>
                    Партнерская программа. Зарабатывайте вместе с ROMI center.
                  </Typography>
                  <Typography variant="body2" style={{ marginBottom: 16 }}>
                    Выплачиваем 100% при первой оплате сервиса ROMI center и
                    далее 30% за каждую следующую оплату от пользователя,
                    который перешел по вашей реферальной ссылке:
                    <span
                      style={{
                        display: 'block',
                        margin: '16px 0',
                        color: 'rgb(136, 102, 255)',
                      }}
                    >
                      {this.state.referral_link}
                    </span>
                  </Typography>

                  <div className={classes.balance}>
                    Баланс:
                    <span style={{ marginRight: 2, marginLeft: 10 }}>
                      {this.state.balance}
                    </span>
                    <Rub width={11} height={11} />
                  </div>

                  <ReactTable
                    data={this.state.table_data}
                    pageSize={this.state.table_data.length}
                    showPagination={false}
                    defaultSorted={[
                      {
                        id: 'register_date',
                        desc: true,
                      },
                    ]}
                    columns={[
                      {
                        Header: 'Email пользователя',
                        accessor: 'email',
                        width: 180,
                      },
                      {
                        Header: 'Дата регистрации',
                        id: 'register_date',
                        accessor: d => d.register_date,
                        width: 123,
                        Cell: ({ value }) => {
                          return format(value, 'YYYY-MM-DD')
                        },
                      },
                      {
                        Header: 'Привязана карта',
                        accessor: 'is_card',
                        width: 120,
                      },
                      {
                        Header: 'Сумма последнего платежа',
                        id: 'last_order_sum',
                        accessor: d => d.last_order_sum,
                        width: 150,
                        Cell: ({ value }) => {
                          return (
                            <Fragment>
                              <span
                                className={classes.referalValue}
                              >{`${thousandSeparator(value)}`}</span>
                              <Rub width={7} height={7} />
                            </Fragment>
                          )
                        },
                      },
                      {
                        Header: 'Сумма предстоящего платежа',
                        id: 'new_order_sum',
                        accessor: d => d.new_order_sum,
                        width: 174,
                        Cell: ({ value }) => {
                          return (
                            <Fragment>
                              <span
                                className={classes.referalValue}
                              >{`${thousandSeparator(value)}`}</span>
                              <Rub width={7} height={7} />
                            </Fragment>
                          )
                        },
                      },
                      {
                        Header: 'Доход с пользователя',
                        id: 'profit',
                        accessor: d => d.profit,
                        width: 140,
                        Cell: ({ value }) => {
                          return (
                            <Fragment>
                              <span
                                className={classes.referalValue}
                              >{`${thousandSeparator(value)}`}</span>
                              <Rub width={7} height={7} />
                            </Fragment>
                          )
                        },
                      },
                    ]}
                    noDataText="Нет данных"
                    style={{ height: 300 }}
                    className="referalTable -striped -highlight"
                  />
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      margin: '16px 0',
                    }}
                  >
                    <Important width={24} heigth={24} />
                    <Typography
                      variant="body2"
                      style={{ marginLeft: 8, fontWeight: 600 }}
                    >
                      Чтобы получить выплату, напишите нам в чат.
                    </Typography>
                  </div>
                </section>
              </Wrapper>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default withStyles(styles)(Referral)
